const SAVE = "SAVE_RETAILERS";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}
